/**
 * Adzuki.TableArrows
 * This will display arrows to a table for smaller screens.
 */

(function TableArrows($, Adzuki)
{
	"use strict";

	// 
	var tableArrows = function arrows(tab)
	{
		var pos = tab.scrollLeft();
		
		tab.on('scroll', function scrollLimit() {
				var width = Math.round(tab.innerWidth()),
				scrollWidth = tab.get(0).scrollWidth;

				pos = tab.scrollLeft();

				// Right end
				if (scrollWidth - pos === width) {
					$('.scroll-arrow.next').fadeOut(200, function nextFadeOut() {
						$(this).addClass('hidden');
					}).fadeIn();
				}

				if (pos > 0 && pos < (scrollWidth - width)) {
					$('.scroll-arrow.prev').removeClass('hidden');
					$('.scroll-arrow.next').removeClass('hidden');
				}

				// Left end
				if (pos === 0) {
					$('.scroll-arrow.prev').fadeOut(200, function prevFadeOut() {
						$(this).addClass('hidden');
					}).fadeIn();
				}
			 });

			$('.scroll-arrow.prev').on('click', function arrowPrev() {
				pos = tab.scrollLeft();
				tab.animate({scrollLeft: pos - 200}, 500);
			});

			$('.scroll-arrow.next').on('click', function arrowNext() {
				pos = tab.scrollLeft();
				tab.animate({scrollLeft: pos + 200}, 500);
			});
	};

	Adzuki.TableArrows = tableArrows;

}(jQuery, window.Adzuki || {}));
